// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2196":"ee8b1517","4577":"2b7b2d2a","4885":"75fc9c18"}[chunkId] || chunkId) + "." + {"2196":"78c6a2d0c413faa5","3040":"4c091d49f4a53953","3458":"9daa90b1d9ebe692","4577":"3a64996c78d55b3c","4885":"5a71081accd18d33","7954":"e138c3d17e151a25","9352":"8e86cd5e5cc760ff"}[chunkId] + ".js";
};